var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { GREEN_DARK, GREEN_SOFT, ORANGE, ORANGE_LIGHT, RED, RED_LIGHTEST, BLUE, BLUE_LIGHT, GREY, GREY_LIGHT, PURPLE, PURPLE_LIGHT, GOLD, GOLD_DARK, CYAN, CYAN_DARK } from 'ui/constants';
var COLORS = {
    orange: {
        color: ORANGE,
        backgroundColor: ORANGE_LIGHT
    },
    gold: {
        color: GOLD_DARK,
        backgroundColor: GOLD
    },
    red: {
        color: RED,
        backgroundColor: RED_LIGHTEST
    },
    blue: {
        color: BLUE,
        backgroundColor: BLUE_LIGHT
    },
    green: {
        color: GREEN_DARK,
        backgroundColor: GREEN_SOFT
    },
    grey: {
        color: GREY,
        backgroundColor: GREY_LIGHT
    },
    purple: {
        color: PURPLE,
        backgroundColor: PURPLE_LIGHT
    },
    cyan: {
        color: CYAN_DARK,
        backgroundColor: CYAN
    },
    default: {
        color: GREY,
        backgroundColor: GREY_LIGHT
    }
};
var Badge = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var color = _a.color, size = _a.size, bold = _a.bold, margin = _a.margin, padding = _a.padding;
    var colorKey = (color || 'default');
    var _b = COLORS[colorKey] || COLORS.default, textColor = _b.color, backgroundColor = _b.backgroundColor;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n      background-color: ", ";\n      font-size: ", "px;\n      font-weight: ", ";\n      margin: ", ";\n      border: none;\n      border-radius: 12px;\n      padding: ", ";\n      display: inline-block;\n      line-height: ", "px;\n    "], ["\n      color: ", ";\n      background-color: ", ";\n      font-size: ", "px;\n      font-weight: ", ";\n      margin: ", ";\n      border: none;\n      border-radius: 12px;\n      padding: ", ";\n      display: inline-block;\n      line-height: ", "px;\n    "])), textColor, backgroundColor, size || 10, bold || 500, margin || 0, padding || '1px 5px', size ? size * 1.8 : 12);
});
export default Badge;
var templateObject_1, templateObject_2;
